import { render } from "./comp-form.vue?vue&type=template&id=778e7d59&ts=true"
import script from "./comp-form.vue?vue&type=script&lang=ts"
export * from "./comp-form.vue?vue&type=script&lang=ts"

import "./comp-form.vue?vue&type=style&index=0&id=778e7d59&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__